export function urlParams(obj) {
  if (!obj) {
    return '';
  }
  let output = '?';
  Object.keys(obj).forEach(key => {
    output += key + '=' + obj[key] + '&';
  });
  output = output.substr(0, output.length - 1);
  return output;
}
